import { useStore } from "../store";
import { fetchAnimes } from "../info";
import { SettingsContainer } from "./SettingsContainer";
import { AnimeInfoSettings } from "./AnimeInfoSettings";
import { AnimeBroadcastSettings } from "./AnimeBroadcastSettings";
import { AnimeImageSettings } from "./AnimeImageSettings";
import { AnimeLinkSettings } from "./AnimeLinkSettings";

const style = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gridTemplateAreas: "'anime broadcast' 'anime images' 'anime link'",
  margin: 80,
  gap: 36
};

export function AnimeSettings(props) {
  const { anime, setAnime } = useStore();

  async function onSave() {
    const animes = await fetchAnimes();
    setAnime(animes.find(a => a.id === anime.id));
  }

  return (<>
    <div style={ style }>
      <SettingsContainer gridArea="anime">
        <AnimeInfoSettings key={ Math.random() } anime={ anime } onSave={ onSave }/>
      </SettingsContainer>

      <SettingsContainer gridArea="broadcast">
        <AnimeBroadcastSettings key={ Math.random() } anime={ anime } onSave={ onSave }/>
      </SettingsContainer>

      <SettingsContainer gridArea="images">
        <AnimeImageSettings key={ Math.random() } anime={ anime } onSave={ onSave }/>
      </SettingsContainer>

      <SettingsContainer gridArea="link">
        <AnimeLinkSettings key={ Math.random() } anime={ anime } onSave={ onSave }/>
      </SettingsContainer>
    </div>
  </>);
}
